import { Component, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import * as echarts from 'echarts';
import { HistoricContextService } from 'app/historic/historic-context.service';
import { MvtService } from '../../common/services/mvt.service';
import {
  FilterSQL,
  secondsToTime,
  secondsToTimeArray,
  formatDate,
  sleep,
} from '../../common/utils';
import { WIDGETS_ID, WIDGET_SQL } from './constants';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

const HOURS = [
  '00',
  '02',
  '04',
  '06',
  '08',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
];
const DAYS = [
  'Domingo',
  'Sábado',
  'Viernes',
  'Jueves',
  'Miércoles',
  'Martes',
  'Lunes',
];

const DATA = [
  [0, 0, 0],
  [0, 1, 0],
  [0, 2, 0],
  [0, 3, 0],
  [0, 4, 0],
  [0, 5, 0],
  [0, 6, 0],
  [0, 7, 0],
  [0, 8, 0],
  [0, 9, 0],
  [0, 10, 0],
  [0, 11, 0],
  [0, 12, 0],
  [0, 13, 0],
  [0, 14, 0],
  [0, 15, 0],
  [0, 16, 0],
  [0, 17, 0],
  [0, 18, 0],
  [0, 19, 0],
  [0, 20, 0],
  [0, 21, 0],
  [0, 22, 0],
  [0, 23, 0],
  [1, 0, 0],
  [1, 1, 0],
  [1, 2, 0],
  [1, 3, 0],
  [1, 4, 0],
  [1, 5, 0],
  [1, 6, 0],
  [1, 7, 0],
  [1, 8, 0],
  [1, 9, 0],
  [1, 10, 0],
  [1, 11, 0],
  [1, 12, 0],
  [1, 13, 0],
  [1, 14, 0],
  [1, 15, 0],
  [1, 16, 0],
  [1, 17, 0],
  [1, 18, 0],
  [1, 19, 0],
  [1, 20, 0],
  [1, 21, 0],
  [1, 22, 0],
  [1, 23, 0],
  [2, 0, 0],
  [2, 1, 0],
  [2, 2, 0],
  [2, 3, 0],
  [2, 4, 0],
  [2, 5, 0],
  [2, 6, 0],
  [2, 7, 0],
  [2, 8, 0],
  [2, 9, 0],
  [2, 10, 0],
  [2, 11, 0],
  [2, 12, 0],
  [2, 13, 0],
  [2, 14, 0],
  [2, 15, 0],
  [2, 16, 0],
  [2, 17, 0],
  [2, 18, 0],
  [2, 19, 0],
  [2, 20, 0],
  [2, 21, 0],
  [2, 22, 0],
  [2, 23, 0],
  [3, 0, 0],
  [3, 1, 0],
  [3, 2, 0],
  [3, 3, 0],
  [3, 4, 0],
  [3, 5, 0],
  [3, 6, 0],
  [3, 7, 0],
  [3, 8, 0],
  [3, 9, 0],
  [3, 10, 0],
  [3, 11, 0],
  [3, 12, 0],
  [3, 13, 0],
  [3, 14, 0],
  [3, 15, 0],
  [3, 16, 0],
  [3, 17, 0],
  [3, 18, 0],
  [3, 19, 0],
  [3, 20, 0],
  [3, 21, 0],
  [3, 22, 0],
  [3, 23, 0],
  [4, 0, 0],
  [4, 1, 0],
  [4, 2, 0],
  [4, 3, 0],
  [4, 4, 0],
  [4, 5, 0],
  [4, 6, 0],
  [4, 7, 0],
  [4, 8, 0],
  [4, 9, 0],
  [4, 10, 0],
  [4, 11, 0],
  [4, 12, 0],
  [4, 13, 0],
  [4, 14, 0],
  [4, 15, 0],
  [4, 16, 0],
  [4, 17, 0],
  [4, 18, 0],
  [4, 19, 0],
  [4, 20, 0],
  [4, 21, 0],
  [4, 22, 0],
  [4, 23, 0],
  [5, 0, 0],
  [5, 1, 0],
  [5, 2, 0],
  [5, 3, 0],
  [5, 4, 0],
  [5, 5, 0],
  [5, 6, 0],
  [5, 7, 0],
  [5, 8, 0],
  [5, 9, 0],
  [5, 10, 0],
  [5, 11, 0],
  [5, 12, 0],
  [5, 13, 0],
  [5, 14, 0],
  [5, 15, 0],
  [5, 16, 0],
  [5, 17, 0],
  [5, 18, 0],
  [5, 19, 0],
  [5, 20, 0],
  [5, 21, 0],
  [5, 22, 0],
  [5, 23, 0],
  [6, 0, 0],
  [6, 1, 0],
  [6, 2, 0],
  [6, 3, 0],
  [6, 4, 0],
  [6, 5, 0],
  [6, 6, 0],
  [6, 7, 0],
  [6, 8, 0],
  [6, 9, 0],
  [6, 10, 0],
  [6, 11, 0],
  [6, 12, 0],
  [6, 13, 0],
  [6, 14, 0],
  [6, 15, 0],
  [6, 16, 0],
  [6, 17, 0],
  [6, 18, 0],
  [6, 19, 0],
  [6, 20, 0],
  [6, 21, 0],
  [6, 22, 0],
  [6, 23, 0],
].map(function (item) {
  return [item[1], item[0], item[2]];
});

const HEATMAP_OPTIONS = {
  grid: {
    height: '85%',
    top: 0,
    left: 60,
    bottom: 20,
    right: 0,
  },
  tooltip: {
    position: function (pos, params, dom, rect, size) {
      // tooltip will be fixed on the right if mouse hovering on the left,
      // and on the left if hovering on the right.
      const obj = {top: pos[1] - 50};
      obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
      return obj;
    },
    backgroundColor: '#2c2c2c',
    borderColor: '#2c2c2c',
    textStyle: {
      fontFamily: 'Roboto',
      color: '#ffffff',
      fontSize: 12,
    },
    padding: [3, 8],
    formatter: function (params) {
      const day = DAYS[params.value[1]];
      const next = HOURS[params.value[0] + 1] || HOURS[0];
      const time = HOURS[params.value[0]] + ':00 a ' + next + ':00 ';
      let value = 'Sin congestión';

      if (params.value[2] === 1) {
        value = 'Level 1';
      } else if (params.value[2] === 2) {
        value = 'Level 2';
      } else if (params.value[2] === 3) {
        value = 'Level 3';
      } else if (params.value[2] === 4) {
        value = 'Level 4';
      } else if (params.value[2] === 5) {
        value = 'Level 5';
      }

      return day + ' de ' + time + ' · ' + value;
    },
  },
  xAxis: {
    type: 'category',
    data: HOURS,
    axisLabel: {
      fontFamily: 'Roboto',
      color: '#747474',
      fontSize: 12,
    },
    splitLine: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: 'category',
    data: DAYS,
    axisLabel: {
      align: 'right',
      fontFamily: 'Roboto',
      color: '#747474',
      fontSize: 12,
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      name: 'test',
      type: 'scatter',
      data: DATA,
      symbolSize: 20,
      itemStyle: {
        opacity: 1,
        color: function (item) {
          const val = item.value[2];

          if (val < 1) {
            return '#8dd99b';
          } else if (val === 1 ) {
            return '#f9cc7d';
          } else if (val === 2) {
            return '#ffb76e';
          } else if (val === 3) {
            return '#f8895f';
          } else if (val === 4) {
            return '#f86650';
          } else if (val === 5) {
            return '#F74541';
          }
        },
      },
      symbol: function (value) {
        const val = value[2];
        // tslint:disable
        if (val < 1) {
          // tslint:disable-next-line
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAa0lEQVQ4je3RLQ6AMAwG0A5TsxvscjsaCZ4bIeeWzLCmFeRD4cgIC0Ht2f6nRMPwmntKAODNLBIRMfPsnNu7pwHworLlWjTXoqKyAfCtmqkVNLMoh4UlrbykleWwcG3b1fBzPSf/+5RhuHcCkKhLbRM9OXYAAAAASUVORK5CYII=';
        } else if (val === 1) {
          // tslint:disable-next-line
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA5UlEQVQ4je2SMW7CQBBF/9gwJs0ixRXcALe+Q3wE3KSFe6XLDZJLpHRuQIlkSxH8dZxJQYJAWMRypISCJ6202tl9O7v6wJWLQ37aYGah9z4BAFUtRKTpfRvJnNtNSdJI2tc879UhyRzWPGD1PET1ult0M2Ca1ZDwPoqix85CMws9t2usnhzWL8fFOAUmWaXR6Lbt+UGb0HufQAK37+yQsgAkcN//2kn4G1qFqlrAPiq42WlxnAD2Xqlq0VkoIg0kWGKa1YhTYHCzG3EKTO5qyGDRKz4k58exeStJzs+d+dtgX/kfPgEKMm1QCePwjwAAAABJRU5ErkJggg==';
        } else if (val === 2) {
          // tslint:disable-next-line
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9UlEQVQ4je2SMW7CQBRE569X8oouuHFvyQFKX4BLgGi4Bz6C75EUKXIJXyBUIAsp1FDgEu1K6/0pHBchS+REKSiYdjRP83cHuOvmRD+ZWusE4JycnQIAC1kCVCil3n8NNOY8B9OTqKuATjsJAByl1g1HDYiXYTh47Q3UWicE3sjtSyiO6y+eizPY8cIwaKKU2l9mhb8f56KugksYAIjDG0RdBQDnvqQXSM5OuzO9/mknidt37dnw7/ICWciSo9ReC3GUWiZZ9gYCVLjhqHFx9s1xcQb38NgAVHiT11oYc56B6flfZtPpc9ir7gPaM6nwzeWuG9YHhfBiED6M19MAAAAASUVORK5CYII=';
        } else if (val === 3) {
          // tslint:disable-next-line
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABP0lEQVQ4je2TMU5CQRiE5/+BvOUAryCBQAyhgQ5PIYmnACmMVHAIohXaGLiEhbeADhqiRIIJRg7A2yA7Fmpi4MHT0DLtv/PtTnZ+4KhDJfuGQRAURKQmzpUBgKoDkl1jzPhfQJJirW0I3TXfZ2t5ezYAgFR+CT8dp2jL87yOiHDTGw8DWmsburJt93ifwHSU+OVKIluEVuptC0cAncgXBkFQELohH+4SmI7Cc+VKkPPLFUVLm/F16waRGhavHzthAPAyBBeztYhUN0fbQOfKmD8ld9O+z80nRpw7jQQeqi0gVQdI5ZdRRqZOAqr2o4FkF346jmxxNy1XgviZGMleJNAYM6ZoSyt1i1wpFKZnF5aCZljB9xR7eSXEDReztcwnBviKKX4mRkHT85K3YcX+y+pVf36Tqn2SvX2rd9Th+gQgq4bQniBD0AAAAABJRU5ErkJggg==';
        } else if (val === 4) {
          // tslint:disable-next-line
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABq0lEQVQ4jd2UwWrbQBCG/9FaWUFbk4CpAibXvkQCDVg+FFQwFOrkTdoXSPsmSaGXUkMPsQ+F5CV6ySEELGpIaFVWK2v199Bi5ERq1Fvpf9yd+fYfZnaA/0IkPZJem9jGIJJda8yRTdOLPLd5ntvcpumFNeaIZLcpT+oOjTH74ooTWSSbPJtqJFe/LsI+ZC+y7IU3Sgdj3/c/3ws0xux74Ckm7xRnE0HpbtWkIIOYiMfO6/jRbegakGTX/ki/yKf3j3n6odb9KnE4Ip+9SPSDh09E5PvqvWpQnmWvZJFscjb5IwwAOPsoski28ix7vVbAWpRzhzyb6jtl1ql04PlUw7nDWiBJD35nZ9WANppfAZ3OTnWkWs3W32gFFJESy+ISYb999nYfKIpLESnvAAEASh3LXmThqRZWFGQ3slDquNYhAGwEwVv2whsZxLyPJ4PnZC+83giCN41AEfmmdDBGPHYyHLHWqacgwxERv3RKBwfVGQQavt5yuXxa5vYEX+dbPJ9qzH93frsP2Y0se+G10sFB3ddrVHU52CwrbJYVleXwqDWoAd56ff37+gnQIsu7rCeouAAAAABJRU5ErkJggg==';
        } else if (val === 5) {
          return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABTElEQVQ4ja2UQU7CQBSGvzdMApF0Y6IH4BRsTBBqEwMXkDXHYo0X0JBAERMW3oILkLhBEgkjzwVtrRaBNvyrSTrv6//PvHlwZsmxDQqybLUuAbzJ5F1AcwMVZB00O1vVnkALqEafVgoTI9Ivj16e9sEzwOX9zZV19pEd6JCV0JVc1xvOFv8Cl0FwbXXzBtQOwn40d9bV01ATLxTE6maQAwZQs192oCljCXAdNDsci7lPir8OGu0McKvayw2La5Gk1ux+ggj4RYGi+HFsAxD12UVRIFCNe9Uc25lXArvIn3e3HxR3uaqMp56AmoiqCmFRVyqE8atJIhuRflGgQZPapCGj2GPy9qIQVkbTIONQQJ11D8A8B27uSq6bHhK/btkbzhbOujpywnkK4d93HBnLaje+Gu0t0hPFJz2+hNCg/fLo9fmk8bUPnmfAnl3fhRF5JObi1gAAAAAASUVORK5CYII='
        }
        // tslint:enable
      },
    },
  ],
};

interface IHours {
  active: boolean;
  from: string;
  to: string;
}

@Component({
  selector: 'app-historic',
  templateUrl: './historic.component.html',
  styleUrls: ['./historic.component.scss'],
})
export class HistoricComponent implements OnInit {
  [x: string]: any;

  activeSections = {
    rushHours: true,
    globalCongestion: true,
    lostDays: true,
    worstPeriodDay: true,
    worstCommute: true,
    worstRoad: true,
  };
  expandedSections = {
    worstPeriodDay: true,
    worstCommute: true,
  };
  worstPeriodDays = [];
  worstPeriodDaysExport = [];
  avgPeriodHoursExport = [];
  avgPeriodHoursList = [];
  avgPeriodHoursListAfternoon = [];
  avgPeriodHoursListExport = [];
  weekEvolutionExport = [];
  durationRushHourAVGInSeconds = 0;
  _avgPeriodHoursExport = [['Horas', 'Minutos', 'Segundos']];
  _avgPeriodHoursListExport = [['Periodo', 'Desde', 'Hasta'], [0, 0, 0], [0, 0, 0]];
  heatmap: any = null;
  startDate = null;
  endDate = null;
  hours = false;
  only = false;
  blockedFilters = false;
  blockedFiltersEvent = false;
  onlySelected: Object = { id: 1, name: 'Nivel de servicio', type: 'variable' };
  onlyOptions = [
    { id: 1, name: 'Nivel de servicio', type: 'variable' },
    { id: 2, name: 'Duración de retención', type: 'variable' },
    { id: 3, name: 'Intensidad del tráfico', type: 'variable' },
  ];
  hoursOptions = [
    { id: 0, name: '00:00' },
    { id: 1, name: '01:00' },
    { id: 2, name: '02:00' },
    { id: 3, name: '03:00' },
    { id: 4, name: '04:00' },
    { id: 5, name: '05:00' },
    { id: 6, name: '06:00' },
    { id: 7, name: '07:00' },
    { id: 8, name: '08:00' },
    { id: 9, name: '09:00' },
    { id: 10, name: '10:00' },
    { id: 11, name: '11:00' },
    { id: 12, name: '12:00' },
    { id: 13, name: '13:00' },
    { id: 14, name: '14:00' },
    { id: 15, name: '15:00' },
    { id: 16, name: '16:00' },
    { id: 17, name: '17:00' },
    { id: 18, name: '18:00' },
    { id: 19, name: '19:00' },
    { id: 20, name: '20:00' },
    { id: 21, name: '21:00' },
    { id: 22, name: '22:00' },
    { id: 23, name: '23:00' },
  ];
  loading = true;
  queryQueue = [];

  @Output() filters: any;
  @Output() hasHours: boolean;
  @Output() fromHour: string;
  @Output() toHour: string;
  @Output() variable: string;
  @Output() bypass: boolean;

  public inputToChild: Object;

  filterUtils = new FilterSQL();

  constructor(
    private historicContextService: HistoricContextService,
    private mvtService: MvtService
  ) {}

  ngOnInit() {
    this.heatmap = echarts.init(document.getElementById('chart'));
    this.onChangeOnly(this.onlySelected);
  }

  receiveDate($event) {
    this.filters = $event;
  }

  clearWidgets() {
    this.worstPeriodDays = [];
    this.worstPeriodDaysExport = [];
    this.avgPeriodHoursExport = [];
    this.avgPeriodHoursList = [];
    this.avgPeriodHoursListAfternoon = [];
    this.avgPeriodHoursListExport = [];
    this.weekEvolutionExport = [];
    this.durationRushHourAVGInSeconds = 0;
    HEATMAP_OPTIONS.series[0].data = [];
    this.heatmap.setOption(HEATMAP_OPTIONS);
  }

  receiveViewPortChange($event) {
    const filters = this.historicContextService.getFilters();
    filters.bbox = $event;
    if (!this.blockedFiltersEvent) {
      this.setDurationMorningData(filters);
      this.setDurationAfternoonData(filters);
      this.setDurationDaysData(filters);
      this.setDurationHoursData(filters);
      this.setWeeklyEvolutionData(filters);
    }
  }

  receiveBlockFilters($event) {
    this.blockedFiltersEvent = $event;
    if (this.blockedFiltersEvent) {
      this.clearWidgets();
    }
  }

  toggleHours() {
    this.hours = !this.hours;
    this.hasHours = this.hours;
  }

  onChangeStart(opt) {
    this.fromHour = opt.name;
  }

  onChangeEnd(opt) {
    if (opt.name <= this.fromHour) {
      alert('La hora de fin debe de ser mayor a la hora de inicio');
      opt.name = this.fromHour;
    } else {
      this.toHour = opt.name;
    }
  }

  toggleOnly() {
    this.only = !this.only;
    this.bypass = this.only;
  }

  onChangeOnly(opt) {
    this.onlySelected = opt.id;
    this.variable = opt;
  }

  getIconForSection(section: any) {
    const collapse = !this.activeSections[section];
    return `/assets/icons/positive/drop-down${
      collapse ? '-collapse' : ''
    }-s.svg`;
  }

  getIconForExpansion(icon, section) {
    const kind = this.expandedSections[section] ? 'secondary' : 'disabled';
    return `/assets/icons/${kind}/${icon}.svg`;
  }

  toggleSection(section) {
    this.activeSections[section] = !this.activeSections[section];
  }

  setQuery(sql: string) {
    if (this.queryQueue.find(x => x === sql)) {
      return false;
    }
    this.queryQueue.push(sql);
    return true;
  }

  removeQuery(sql: string) {
    const queue = this.queryQueue.filter(x => x !== sql);
    this.queryQueue = queue;
    this.loading = this.queryQueue.length !== 0;
  }

  toggleExpandedSection(section: any) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  setDurationDaysData(filters: any) {
    const p = [];
    const _worstPeriodDays = [];
    const _worstPeriodDaysExport = [];
    const sql = this.filterUtils.filterQuery(
      WIDGET_SQL[WIDGETS_ID.DURATION_DAYS],
      filters
    );

    if (!this.setQuery(sql)) {
      return;
    }

    p.push(this.mvtService.getAPIData(sql).toPromise());
    Promise.all(p)
      .then(async (values: any) => {
        await sleep(100);
        values[0].rows.forEach((day) => {
          _worstPeriodDays.push({
            date: formatDate(day.date, 'YYYY-MM-DDThh:mm:ssZ', 'LL', 'ES-es'),
            duration: secondsToTime(day.duration_seconds), // Math.floor(day.duration_seconds / 60)
          });
          const durationArr = secondsToTimeArray(day.duration_seconds);
          // tslint:disable
          _worstPeriodDaysExport.push({
            "Fecha": formatDate(day.date, 'YYYY-MM-DDThh:mm:ssZ', 'DD/MM/YYYY', 'ES-es'),
            "Horas": durationArr[0],
            "Minutos": durationArr[1],
            "Segundos": durationArr[2],
          });
          // tslint:enable
        });
        this.worstPeriodDays = _worstPeriodDays;
        this.worstPeriodDaysExport = _worstPeriodDaysExport;
        this.removeQuery(sql)
      })
      .catch((error) => {
        this.removeQuery(sql)
      });
  }

  setDurationMorningData (filters: any) {
    const _avgPeriodHoursList = [];
    const sql = this.filterUtils.filterQuery(
      WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS_LIST_DAY],
      filters
    );

    if (!this.setQuery(sql)) {
      return;
    }

    const p = [];
    p.push(this.mvtService.getAPIData(sql).toPromise());
    Promise.all(p)
      .then(async (values: any) => {
        await sleep(200);
        values[0].rows.forEach((item) => {
          const from_from = moment(item.range_morning_from, 'YYYY-MM-DDThh:mm:ssZ').add(-2, 'hours').format('HH:mm');
          const from_to = moment(item.range_morning_to, 'YYYY-MM-DDThh:mm:ssZ').add(-2, 'hours').format('HH:mm');
          _avgPeriodHoursList.push({
            from: from_from + ' Hasta ' + from_to,
          });
          this._avgPeriodHoursListExport[1] = ['1', from_from, from_to];
        });
        this.avgPeriodHoursList = _avgPeriodHoursList;
        this.removeQuery(sql);
      })
      .catch((error) => {
        this.removeQuery(sql);
      });
  }

  setDurationAfternoonData (filters: any) {
    const _avgPeriodHoursList = [];
    const sql = this.filterUtils.filterQuery(
      WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS_LIST_AFTERNOON],
      filters
    );

    if (!this.setQuery(sql)) {
      return;
    }

    const p = [];
    p.push(this.mvtService.getAPIData(sql).toPromise());
    Promise.all(p)
      .then(async (values: any) => {
        await sleep(300);
        values[0].rows.forEach((item) => {
          const from_from = moment(item.range_afternoon_from, 'YYYY-MM-DDThh:mm:ssZ').add(-2, 'hours').format('HH:mm');
          const from_to = moment(item.range_afternoon_to, 'YYYY-MM-DDThh:mm:ssZ').add(-2, 'hours').format('HH:mm');
          _avgPeriodHoursList.push({
            from: from_from + ' Hasta ' + from_to,
          });
          this._avgPeriodHoursListExport[2] = ['2', from_from, from_to];
        });
        this.avgPeriodHoursListAfternoon = _avgPeriodHoursList;
        this.removeQuery(sql);
        // this.avgPeriodHoursListExport = this._avgPeriodHoursListExport;
      }).catch((error) => {
        this.removeQuery(sql);
      });
  }

  setDurationHoursData(filters: any) {
    const p = [];
    const _avgPeriodHoursExport = [['Horas', 'Minutos', 'Segundos']];
    const sql = this.filterUtils.filterQuery(
      WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS],
      filters
    );

    if (!this.setQuery(sql)) {
      return;
    }

    p.push(this.mvtService.getAPIData(sql).toPromise());
    Promise.all(p)
      .then(async (values: any) => {
        await sleep(400);
        values[0].rows.forEach((day) => {
          this.durationRushHourAVGInSeconds = day.duration_seconds
          const durationArr = secondsToTimeArray(day.duration_seconds);
          _avgPeriodHoursExport.push([...durationArr]);
        });

        this.avgPeriodHoursExport = _avgPeriodHoursExport;
        this.removeQuery(sql)
      })
      .catch((error) => {
        this.removeQuery(sql)
      });
  }

  setWeeklyEvolutionData(filters: any) {
    const p = [];
    const days = [];
    const daysExport = [];
    const sundayExport = [];
    let _dataExport = null;
    let _sql = '';

    switch (filters.variable.id) {
      case 1:
        _sql = WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_SERVICE_LEVEL]
        break;
      case 2:
        _sql = WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_JAM_DURATION]
        break;
      case 3:
        _sql = WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_TRAFFIC_INTENSITY]
        break;
      default:
        _sql = WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_SERVICE_LEVEL]
    }
    const sql = this.filterUtils.filterQuery(_sql, filters);

    if (!this.setQuery(sql)) {
      return;
    }

    p.push(this.mvtService.getAPIData(sql).toPromise());

    Promise.all(p)
      .then(async (values: any) => {
        await sleep(500);
        values[0].rows.forEach((item: any) => {
          const currentDay = item.day === 1 ? 6 : (6 - item.day) + 1;
          days.push([item.hour, currentDay, item.level]);
          if (HOURS[item.hour]) {
            // Sunday to bottom of export
            if (currentDay === 6) {
              sundayExport.push({
                day: DAYS[currentDay],
                hour: HOURS[item.hour],
                level: item.level
              });

            } else {
              daysExport.push({
                day: DAYS[currentDay],
                hour: HOURS[item.hour],
                level: item.level
              });
            }
          }
        });

        _dataExport = [...daysExport, ...sundayExport];

        const newData = days; // days.map(function (item) {return [item[1], item[0], item[2]]});

        // Chart data
        HEATMAP_OPTIONS.series[0].data = newData;
        this.heatmap.setOption(HEATMAP_OPTIONS);

        // Export data
        const option = this.heatmap.getOption();
        const exportData = [['', ...option.xAxis[0].data]];
        const yData = option.yAxis[0].data.reverse();
        const noJAm = 'Sin congestión';

        yData.forEach((day: string, idx: number) => {
          const _data = _dataExport.filter(x => x.day === day)
          if (_data.length === 0) {
            exportData[idx + 1] = [day, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm, noJAm];
          } else {
            const _day = _data.reduce(function(arr, item, i) {
                arr[i] = item.level === 0 ? noJAm : `Level ${item.level}`;
                return arr;
            }, []);
            exportData[idx + 1] = [day, ..._day];
          }
        });

        this.weekEvolutionExport = exportData;
        this.removeQuery(sql);
      })
      .catch((error) => {
        this.removeQuery(sql);
      });
  }

  getTime (sec: number) {
    return secondsToTime(sec);
  }

  export() {
    // tslint:disable
    // DOCS from https://github.com/SheetJS/sheetjs/tree/1d7aff45c820105fc7d007c5f64c97f592345320
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.worstPeriodDaysExport);
    const whp: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.avgPeriodHoursExport);
    const whpl: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this._avgPeriodHoursListExport);
    const wel: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.weekEvolutionExport);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Días de mayor congestión');
    XLSX.utils.book_append_sheet(wb, whp, 'D.M de la hora punta');
    XLSX.utils.book_append_sheet(wb, whpl, 'D.M de la hora punta (desglose)');
    XLSX.utils.book_append_sheet(wb, wel, 'Evolución semanal y horaria');
    /* save to file */
    XLSX.writeFile(wb, `${moment().format('DDMMYYYHHmmss')}_AMB_HISTORICO.xlsx`);
    // tslint:enable
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/historic/historic.component.ts